import React from 'react';

import { Text } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

export const TicketType: React.FC<{ value: string }> = ({ value }) => {
  const { t } = useTranslation();
  const other = t('ticket:ticketTypes.other');
  const ticketType = t(`ticket:ticketTypes.${value}`, other);

  return (
    <Text whiteSpace="nowrap" styledAs="body3">
      {ticketType}
    </Text>
  );
};
